import { useRef } from 'react'

const getStateKey = () =>
  typeof window !== 'undefined' ? window.history?.state?.key : null

export type HistoryState = { idx: 0 | 1 }

export let isFirstPage = () => true

export const useHistoryState = (): HistoryState => {
  const routeKeyRef = useRef<string | null>(getStateKey())

  isFirstPage = () => routeKeyRef.current === getStateKey()

  return { idx: isFirstPage() ? 0 : 1 }
}
